import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { validateOrdinaryPostAuthNext } from "@/lib/auth-paths";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [message, setMessage] = useState("Đang xử lý xác nhận...");
  const [error, setError] = useState("");

  useEffect(() => {
    const code = params.get("code");
    const type = params.get("type");
    const next = params.get("next");

    if (!code) {
      setMessage("");
      setError("Liên kết không hợp lệ (thiếu mã xác nhận).");
      return;
    }

    let active = true;

    supabase.auth
      .exchangeCodeForSession(code)
      .then(({ data, error: exchangeError }) => {
        if (!active) return;
        if (exchangeError) {
          setMessage("");
          setError(exchangeError.message);
          return;
        }

        // Xác định luồng đặt lại mật khẩu dựa trên nhiều tín hiệu để chắc chắn:
        // - type=recovery (Supabase thêm vào link email)
        // - data.redirectType
        // - next do chính mình đặt khi gửi link quên mật khẩu
        const isRecovery =
          type === "recovery" ||
          data.redirectType === "recovery" ||
          next === "/auth/reset-password";

        if (isRecovery) {
          navigate("/auth/reset-password", { replace: true });
          return;
        }

        navigate(validateOrdinaryPostAuthNext(next), { replace: true });
      })
      .catch(() => {
        if (!active) return;
        setMessage("");
        setError("Có lỗi xảy ra khi xử lý xác nhận. Vui lòng thử lại.");
      });

    return () => {
      active = false;
    };
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-lg border border-background-200/70 p-6 text-center">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
          <i className="ri-loader-4-line animate-spin text-2xl" />
        </div>
        <h1 className="font-display text-xl font-bold text-foreground-950 mb-2">
          Xác nhận tài khoản
        </h1>
        {error ? (
          <p className="text-sm text-foreground-600 font-body">{error}</p>
        ) : (
          <p className="text-sm text-foreground-600 font-body">{message}</p>
        )}
      </div>
    </div>
  );
}